import { Form, Select } from "antd";
import { SelectOption } from "../../types/common.type";
import { IconStar, IconStarFilled } from "@tabler/icons-react";
import RateStarSelect from "./RateStarSelect";
const { Option } = Select;
const RateFormSelect = ({
  className,
  style,
  onChange,
  placeholder,
  name,
}: {
  className?: string;
  onChange?: any;
  placeholder?: string;
  style?: React.CSSProperties | undefined;
  name: string;
}) => {
  const styles = {
    optStyle: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: "12px",
    },
    optStyleLeft: {
      display: "flex",
    },
    optStar: {
      color: "#d72229",
    },
  };
  const dropdownRender = (menu: any) => (
    <div>
      <div style={{ textAlign: "center" }}>{menu}</div>
    </div>
  );
  return (
    <Form.Item name={name}>
      <Select
        className={className}
        style={{ width: "100%", textAlign: "center", ...style }}
        onChange={onChange}
        placeholder={placeholder}
        dropdownRender={dropdownRender}
        allowClear
      >
        <Option value={0}>Tất cả</Option>
        <Option value={1}>
          <div style={{ ...styles.optStyle }}>
            <div style={{ ...styles.optStyleLeft }}>
              <RateStarSelect stars={1} />
            </div>
            <div>1 sao</div>
          </div>
        </Option>
        <Option value={2}>
          <div style={{ ...styles.optStyle }}>
            <div style={{ ...styles.optStyleLeft }}>
              <RateStarSelect stars={2} />
            </div>
            <div>2 sao</div>
          </div>
        </Option>
        <Option value={3}>
          <div style={{ ...styles.optStyle }}>
            <div style={{ ...styles.optStyleLeft }}>
              <RateStarSelect stars={3} />
            </div>
            <div>3 sao</div>
          </div>
        </Option>
        <Option value={4}>
          <div style={{ ...styles.optStyle }}>
            <div style={{ ...styles.optStyleLeft }}>
              <RateStarSelect stars={4} />
            </div>
            <div>4 sao</div>
          </div>
        </Option>
        <Option value={5}>
          <div style={{ ...styles.optStyle }}>
            <div style={{ ...styles.optStyleLeft }}>
              <RateStarSelect stars={5} />
            </div>
            <div>5 sao</div>
          </div>
        </Option>
      </Select>
    </Form.Item>
  );
};

export default RateFormSelect;
